export const longTitle = "Toolbar with a very very very very very very very very very long title";
export const shortTitle = "Toolbar title";